import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/types/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: (failureCount, error) => {
        // Never retry auth/validation errors; retry transient ones once.
        if (error instanceof ApiError && error.code >= 400 && error.code < 500) {
          return false;
        }
        return failureCount < 1;
      },
      // A POS terminal is always focused — surprise refetches hurt UX.
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
